import React from "react"
import styled from "styled-components"
import { media } from "src/styles/breakpoints"
import { PrimaryTitle } from "src/components/Typography"
import { CategoryIconWrapper, CategoryIcon } from "src/pages/resources"
import Breadcrumbs from "src/components/Breadcrumbs"

const ResourcesHeader = ({
  title,
  titlePrefix,
  description,
  breadcrumbs,
  icon,
}) => {
  return (
    <Wrapper
      className={`
        ${description ? "-has-description" : ""}
        ${icon ? "-has-icon" : ""}
      `}
    >
      <StyledBreadcrumbs items={breadcrumbs} />
      <Title as="h1">
        {titlePrefix && <small>{titlePrefix}</small>} {title}
      </Title>
      {description && <Description>{description}</Description>}
      {icon && (
        <IconWrapper style={{ color: icon.color }}>
          <CategoryIcon name={icon.name} source="feather" />
        </IconWrapper>
      )}
    </Wrapper>
  )
}

const Wrapper = styled.header`
  margin-bottom: 20px;
  position: relative;

  ${media.tablet} {
    margin-bottom: 61px;
    padding-top: 6px;
    padding-right: ${(p) => p.theme.sidePadding.tablet}px;

    &.-has-description {
      margin-bottom: 80px;
    }
  }

  ${media.desktop} {
    padding-right: ${(p) => p.theme.sidePadding.desktop}px;
  }
`

const StyledBreadcrumbs = styled(Breadcrumbs)`
  ${media.tablet} {
    margin-top: 14px;

    ${Wrapper}.-has-icon & {
      margin-left: 90px;
    }
  }
`

const Title = styled(PrimaryTitle)`
  max-width: 724px;
  margin-bottom: 7px;
`

const Description = styled.p`
  font-size: 15px;
  color: ${(p) => p.theme.color.textLight};
`

const IconWrapper = styled(CategoryIconWrapper)`
  display: none;
  position: absolute;
  top: 0;
  left: 0;

  ${media.tablet} {
    display: flex;
  }
`

export default ResourcesHeader
